<template>
  <div class="PaB-chip" :class="{'PaB-chip--dismissable': dismissable}" v-on="dismissable ? {click: () => dismiss()} : {}">
    <div class="PaB-chip__text">
      <slot></slot>
    </div>
    <button v-if="dismissable" class="PaB-chip__dismiss">
      <icon-base icon-name="dismiss" width="12" height="12">
        <icon-close />
      </icon-base>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.PaB-chip {
  padding: 0 6px;
  border-radius: 50px;
  color: #fff;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
}
.PaB-chip__text {
  font-weight: 700;
  display: inline-block;
  vertical-align: baseline;
  white-space: nowrap;
  font-size: 12px;
  padding-left: 6px;
  padding-right: 6px;
  line-height: 25px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.PaB-chip__dismiss {
  flex: 0 0 auto;
  display: inline-block;
  border-radius: 100%;
  border: 0;
  padding: 0;
  margin-right: 6px;
  background-color: transparent;
  color: #fff;
}
</style>

<script>
import IconBase from '@/components/IconBase'
import IconClose from '@/components/icons/IconClose'
export default {
  props: {
    dismissable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    IconBase,
    IconClose
  },
  methods: {
    dismiss: function () {
      this.$emit('dismissed')
    }
  }
}
</script>
